import gsap from 'gsap'
import Component from 'Scripts/classes/Component'

export default class extends Component {
  constructor() {
    super({
      container: '.mobile__filters_wrapper',
      elements: {
        mobileFiltersTrigger: '.mobile__filters_trigger',
        mobileFiltersWrapper: '.mobile__filters_wrapper',
        mobileFiltersClose: '.filters__close',
        mobileFilter: '[data-filter]',
        mobileFilterResult: '.mobile__filters_wrapper .filters__footer_result',
      }
    })

    // const isMobile = document.documentElement.classList.contains('mobile')
    this.elements.mobileFiltersTrigger && this.addEventListeners()

  }

  filtersOn(event) {
    event.preventDefault()
    this.filtersTl = gsap.timeline({})
    this.filtersTl.set(this.elements.mobileFiltersWrapper, {
      autoAlpha: 1
    })
    this.filtersTl.to(this.elements.mobileFiltersWrapper, {
      x: 0,
      duration: 1,
      ease: 'Power4.in'
    })
  }

  filtersOff(event) {
    event.preventDefault()
    
    this.filtersTl.timeScale(2).reverse()
  }



  removeEventListeners() {
    this.elements.mobileFiltersTrigger?.removeEventListener('click', this.filtersOn.bind(this), false)
    this.elements.mobileFiltersClose?.removeEventListener('click', this.filtersOff.bind(this), false)
    // this.elements.mobileFilter?.forEach(elm => {
    //   elm.removeEventListener('click', this.filtersOff.bind(this), false)
    // })
    this.elements.mobileFilterResult?.removeEventListener('click', this.filtersOff.bind(this), false)

  }

  addEventListeners() {
    this.elements.mobileFiltersTrigger?.addEventListener('click', this.filtersOn.bind(this), false)
    this.elements.mobileFiltersClose?.addEventListener('click', this.filtersOff.bind(this), false)
    // this.elements.mobileFilter?.forEach(elm => {
    //   elm.addEventListener('click', this.filtersOff.bind(this), false)
    // })
    this.elements.mobileFilterResult?.addEventListener('click', this.filtersOff.bind(this), false)

  }

  destroy() {
    this.removeEventListeners()

  }
}